export { default as ExamplePengu } from './example-pengu.png';
export { default as Common } from './01.png';
export { default as Uncommon } from './02.png';
export { default as Rare } from './03.png';
export { default as UltraRare } from './04.png';
export { default as SecretRare } from './05.png';

import type { CollectionResponseDtoRarity } from '~/lib/api';
import CommonBg from './01.png';
import UncommonBg from './02.png';
import RareBg from './03.png';
import UltraRareBg from './04.png';
import SecretRareBg from './05.png';

export const getRarityBackground = (rarity: CollectionResponseDtoRarity) => {
  switch (rarity) {
    case 'common':
      return CommonBg;
    case 'uncommon':
      return UncommonBg;
    case 'rare':
      return RareBg;
    case 'ultra_rare':
      return UltraRareBg;
    case 'legendary':
      return SecretRareBg;
    case 'ultimate':
      return SecretRareBg; // Using SecretRare background as fallback
    case 'heirloom':
      return SecretRareBg; // Using SecretRare background as fallback
    default:
      return CommonBg;
  }
};
